// extracted by mini-css-extract-plugin
export default {"container":"Copyright__container___YL8MM","allRightsReserved":"Copyright__allRightsReserved___zdMnB"};